/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DepartmentUpdate
 */
export interface DepartmentUpdate {
    /**
     * 
     * @type {string}
     * @memberof DepartmentUpdate
     */
    label?: string | null;
}

/**
 * Check if a given object implements the DepartmentUpdate interface.
 */
export function instanceOfDepartmentUpdate(value: object): value is DepartmentUpdate {
    return true;
}

export function DepartmentUpdateFromJSON(json: any): DepartmentUpdate {
    return DepartmentUpdateFromJSONTyped(json, false);
}

export function DepartmentUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): DepartmentUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'label': json['label'] == null ? undefined : json['label'],
    };
}

export function DepartmentUpdateToJSON(json: any): DepartmentUpdate {
    return DepartmentUpdateToJSONTyped(json, false);
}

export function DepartmentUpdateToJSONTyped(value?: DepartmentUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'label': value['label'],
    };
}

